import { render, staticRenderFns } from "./StudioMediaDetailsSidebar.vue?vue&type=template&id=d0cd12b4&scoped=true&"
import script from "./StudioMediaDetailsSidebar.vue?vue&type=script&lang=ts&"
export * from "./StudioMediaDetailsSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./StudioMediaDetailsSidebar.vue?vue&type=style&index=0&id=d0cd12b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cd12b4",
  null
  
)

export default component.exports